import { sva } from '@allenai/varnish-panda-runtime/css';
import type { RecipeVariantProps } from '@allenai/varnish-panda-runtime/types';

const formInputContainerRecipe = sva({
    slots: ['root', 'actions'],
    base: {
        root: {
            fontFamily: 'body',

            borderRadius: 'sm',
            // outlined variant will add borderColor
            border: '1px solid transparent',
            colorPalette: 'elements.overrides.form.input',
            color: 'text',

            display: 'flex',

            _groupDisabled: {
                cursor: 'not-allowed',
                colorPalette: 'elements.overrides.form.input.disabled',
                borderColor: 'colorPalette.stroke',
            },
            _groupInvalid: {
                colorPalette: 'elements.overrides.form.input.error',
                borderColor: 'colorPalette.stroke',
            },
            _groupHoverNotDisabledNotSelected: {
                colorPalette: 'elements.overrides.form.input.hovered',
                borderColor: 'colorPalette.stroke',
            },

            alignItems: 'center',
        },
        actions: {
            display: 'flex',
            alignItems: 'center',
        },
    },
    variants: {
        variant: {
            contained: {
                root: {
                    backgroundColor: 'colorPalette.fill',
                },
            },
            outlined: {
                root: {
                    borderColor: 'colorPalette.stroke',
                    backgroundColor: 'transparent',
                },
            },
        },
        size: {
            small: {
                root: {
                    fontSize: '[12px]',
                    lineHeight: '[1rem]',
                    '& input, & textarea': {
                        padding: '[11px 11px]',
                    },
                },
            },
            medium: {
                root: {
                    fontSize: 'sm',
                    lineHeight: '[1.375rem]',
                    '& input, & textarea': {
                        padding: '[7px 11px]',
                    },
                },
            },
            large: {
                root: {
                    fontSize: 'lg',
                    lineHeight: '1.5rem',
                    '& input, & textarea': {
                        padding: '[15px 15px]',
                    },
                },
            },
        },
        shape: {
            box: {},
            rounded: {
                root: {
                    borderRadius: '[28px]',
                    borderWidth: '[2px]',
                },
            },
        },
        fullWidth: {
            false: {},
            true: {
                root: {
                    width: '[100%]',
                },
            },
        },
    },
    compoundVariants: [
        {
            size: ['small', 'medium', 'large'],
            shape: 'rounded',
            css: {
                root: {
                    '& input, & textarea': {
                        paddingInline: '[24px]',
                    },
                },
            },
        },
    ],
    defaultVariants: {
        variant: 'outlined',
        shape: 'box',
        size: 'medium',
        fullWidth: false,
    },
});

type FormInputContainerRecipeProps = Exclude<
    RecipeVariantProps<typeof formInputContainerRecipe>,
    undefined
>;

export { formInputContainerRecipe, formInputContainerRecipe as default };
export type { FormInputContainerRecipeProps };
